module.exports = __webpack_public_path__ + "img/shipo-icon-file-download.557f02a5.svg";